import constants from 'constants';

const {
  CREATE_PARTNER_SAGA,
  LOAD_ADMIN_PARTNERS_SAGA,
  ADD_ADMIN_PARTNERS,
  UPDATE_PARTNER_SAGA,
  DELETE_PARTNER_SAGA,
  ADMIN_DELETE_PARTNERS_SAGA,
  ADD_PARTNERS,
  LOAD_PARTNERS_SAGA,
  LOAD_PARTNER_SAGA,
  SET_TEMP_PARTNER,
  CLEAN_PARTNERS
} = constants;


export const createPartnerSaga = (partner) => ({
  type: CREATE_PARTNER_SAGA,
  partner
})

export const updatePartnerSaga = (partner) => ({
  type: UPDATE_PARTNER_SAGA,
  partner
})

export const deletePartnerSaga = (partner) => ({
  type: DELETE_PARTNER_SAGA,
  partner
})

export const loadAdminPartnersSaga = (page = 1, query = {}) => ({
  type: LOAD_ADMIN_PARTNERS_SAGA,
  query,
  page
})

export const loadPartnersSaga = () => ({
  type: LOAD_PARTNERS_SAGA
})

export const addAdminPartners = (values, count, page, total_pages, query = {}) => ({
  type: ADD_ADMIN_PARTNERS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const addPartners = (values) => ({
  type: ADD_PARTNERS,
  payload: {
    values
  }
})

export const adminDeletePartnerSaga = (partner_ids) => ({
  type: ADMIN_DELETE_PARTNERS_SAGA,
  partner_ids
})

export const setTempPartner = (partner) => ({
  type: SET_TEMP_PARTNER,
  payload: {
    partner
  }
})

export const loadPartnerSaga = (id) => ({
  type: LOAD_PARTNER_SAGA,
  id
})

export const cleanPartner = () => ({
  type: CLEAN_PARTNERS
})



// WEBPACK FOOTER //
// ./src/actions/partners.js